// 不同domain配置

export const TestApi = {
  onlineEnv: "xintin.cn/txsy/admin/api",
  devEnv: "127.0.0.1:8082",
  // devEnv: "81.68.126.238:8082",
  rapEnv: "127.0.0.1:8082",
};




